import React, { useEffect, useState } from 'react'
import { Drawer, Form, notification, Table } from 'antd'
import { connect } from 'react-redux'
import { useDispatch } from 'react-redux'
import {
  displayDate,
  longDisplayDate,
  getcurrencySymbols
} from '../../../components/_utils/appUtils'
import StatusComponent from '../Components/statusComponent'
import { allPendingCommissionListFxn } from '../actions'
import AddClaimByStudent from './addClaimByStudent'

let claimRecInit = {
  visible: false,
  record: [],
  commissionCurrency: ''
}


const ClaimCommissionComponent = (props) => {
  let dispatch = useDispatch()
  const [claimRecState, setClaimRecState] = useState(claimRecInit)
  const [itemNo, setItemNo] = useState(1)
  const [commissionListRecords, setCommissionListRecords] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  let { visible, onClose, data, commissionCurrency } = props

  const [selectionType, setSelectionType] = useState('checkbox')

  const handleClaimCommission = (selectedRows, events) => {
    if (selectedRows && selectedRows.length > 0) {
      events.showClaimRecDrawer(selectedRows)
    } else {
      notification.warning({
        message: 'Please Select Student Commission'
      })
    }
  }

  const rowSelection = {
    selectedRowKeys, // control selected checkboxes
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys)
      setSelectedRows(rows)
    }
  }

  const resetSelection = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
  }
  const events = {
    showClaimRecDrawer: (record) => {
      setClaimRecState({
        visible: true,
        record: record,
        commissionCurrency: record.currency
      })
    },
    hideClaimRecDrawer: () => {
      setClaimRecState({
        visible: false,
        record: [],
        commissionCurrency: ''
      })
      resetSelection()
    },
    loadCommissionList: async () => {
      let obj = {
        universityId: data.universityId
      }
      let { data: commissionList } = await dispatch(allPendingCommissionListFxn(obj))
      setCommissionListRecords(commissionList || [])
      resetSelection()
    }
  }

  useEffect(() => {
    events.loadCommissionList()
  }, [data])

  const totalSelectedAmount = selectedRows.reduce((sum, row) => sum + (row.amount || 0), 0)
  const columns = [

    {
      title: 'S.No',
      dataIndex: 'sno',
      width: 50,
      key: 'sno',
      render: (item, record, index) => {
        return (
          <a className={'linkPointer'}>
            {(itemNo - 1) * 10 + index + 1}
          </a>
        )
      }
    },
    {
      title: 'App ID',
      key: 'appId',
      dataIndex: 'appId',
      // searchTextName: 'appId',
      width: 80,
      render: (item) => {
        return (
          <div style={{ width: 80 }}>
            {item}
          </div>
        )
      }
    },
    {
      title: 'Invoice Date',
      dataIndex: 'invoiceDate',
      key: 'invoiceDate',
      width: 120,
      render: (item, record) => {
        return (
          <div style={{ width: 150 }}>
            {item ? displayDate(item) : ''}
          </div>
        )
      }
    },
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
      width: 150,
      render: (item, record) => {
        return (
          <div style={{ width: 150 }}>
            {item}<br />
            (ID
            : {record.commissionDetails && record.commissionDetails.offerLetterStudentId ? record.commissionDetails.offerLetterStudentId : ''})
          </div>
        )
      }
    },
    {
      title: 'Program',
      key: 'courseName',
      dataIndex: 'courseName',
      width: 180,
      render: (item, record) => {
        return (
          <div style={{ width: 180 }}>
            {item}
          </div>
        )
      }
    },
    {
      title: 'Semester',
      dataIndex: 'semester',
      key: 'semester',
      width: 120
    },

    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: 170,
      render: (item, record) => {
        return (
          <>
            <StatusComponent record={record} />
          </>
        )
      }
    },


    {
      title: 'Intake',
      key: 'intake',
      dataIndex: 'intake',
      width: 120,
      render: (item, record) => {
        return (
          <div style={{ width: 150 }}>
            {item && item.month && item.year ? `${item.month}, ${item.year}` : ''}
          </div>
        )
      }
    },

    {
      title: 'Semester Fee',
      dataIndex: 'semesterFee',
      key: 'semesterFee',
      width: 120,
      render: (item, record) => {
        let { currency } = record
        return (
          <div style={{ width: 150 }}>
            {item}
            {currency ? ` ${currency}` : ''}
          </div>
        )
      }
    },
    {
      title: 'Commission',
      dataIndex: 'amount',
      key: 'amount',
      width: 150,
      render: (item, record) => {
        let { currency } = record
        return (
          <div style={{ width: 150 }}>
            {item}
            {currency ? ` ${currency}` : ''}
          </div>
        )
      }
    },
    {
      title: 'Paid Date',
      key: 'invoicePaidDate',
      dataIndex: 'invoicePaidDate',
      width: 160,
      render: (item, record) => {
        return (
          <div style={{ width: 160 }}>
            <div>{longDisplayDate(record.createdAt)}</div>
          </div>
        )
      }
    },
    {
      title: 'Offer S.ID',
      dataIndex: 'offerLetterStudentId',
      key: 'offerLetterStudentId',
      width: 100,
      render: (item, record) => {
        let { commissionDetails } = record
        return (
          <div style={{ width: 100 }}>
            {commissionDetails.offerLetterStudentId ? commissionDetails.offerLetterStudentId : ''}
          </div>
        )
      }
    }
  ]
  const titleContent = (
    <div className='claim-title'>
      <div>
        Claim Commission&nbsp;&nbsp;&nbsp;&nbsp;
        (Total Amount: {getcurrencySymbols[commissionCurrency]}{totalSelectedAmount})
      </div>


    </div>
  )


  return (
    <>
      <Drawer
        visible={visible}
        onClose={onClose}
        title={titleContent}
        width={'95%'}>
        <div className='form-box commissionBox'>
          <div className='card unizportal'>
            <div className='card-body table-responsive'>
              <Table
                rowKey={item => item._id}
                rowSelection={{ type: selectionType, ...rowSelection }}
                columns={columns}
                dataSource={commissionListRecords}
                pagination={false}>
              </Table>
            </div>
            <a onClick={() => handleClaimCommission(selectedRows, events)}
               className={'btn btn-success roundNew mt20 lg'}>
              Claim Commission
            </a>
          </div>
        </div>
        {claimRecState.visible ?
          <AddClaimByStudent
            visible={claimRecState.visible}
            onClose={events.hideClaimRecDrawer}
            record={claimRecState.record}
            commissionCurrency={commissionCurrency}
            universityData={data}
            refreshFxn={events.loadCommissionList}
          /> : null}
      </Drawer>
    </>
  )
}

const ClaimCommission = Form.create()(ClaimCommissionComponent)
const mapStateToProps = ({ global, router }) => ({
  currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClaimCommission)
